import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHomeAlt,
} from '@fortawesome/free-solid-svg-icons';
import {
  Box, Grid, Typography, Breadcrumbs, Button,
} from '@mui/material';

import { Link } from 'react-router-dom';
import { Form } from '@unform/web';

import { HOME, USERS } from 'Shared/Constant/Routes';
import { IUserDetailPage } from '../Interface';
import UserHeaderPage from './UserHeader/index';
import FieldsByGroupCustomPage from 'Shared/Components/Form/FieldsByGroupCustom/index';
import { IUsers } from 'Module/Users/Interface';
import ModalQuestionYesNoPage from 'Shared/Components/ModalQuestionYesNo/index';
import { IModalQuestionYesNoPage } from 'Shared/Components/ModalQuestionYesNo/Interface';
import TypeAnswerConstant from 'Shared/Constant/TypeAnswer/index';

function UserDetailPage(props: IUserDetailPage) {
  const formDefault = React.useRef<any>(null);

  const [userUpdate, setUserUpdate] = React.useState<IUsers>({});
  const [userIDUpdate, setUserIDUpdate] = React.useState<string>('');

  const [fieldActive, setFieldActive] = React.useState<boolean>(false);
  const [fieldDepartment, setFieldDepartment] = React.useState<string>('');

  const handleChangeCurrency = (event: any, value: any, maskedValue: any) => {
    //handleChangeCurrency
  };


  const handleChangeSelect = (event: any, field?: string) => {
    switch (field) {
      case 'active':
        setFieldActive(event.value)
        break;
      case 'department':
        setFieldDepartment(event.value)
        break;
      default:
        break;
    }
  }

  const handleSubmit = (data: any) => {
    // const keys = Object.keys(props.item);
    const _id = props.item.guidcontrol ? props.item.guidcontrol : data.id;
    let _reg: IUsers = {
      rcacode: data.rcacode,
      name: `${data.name}`.toUpperCase().trim(),
      alias: `${data.name}`.toUpperCase().trim(),
      documentnumber: `${data.documentnumber}`.toUpperCase().trim(),
      department: fieldDepartment,
      email: `${data.rcacode}@teste.com.br`,
      active: fieldActive,
      userupdate: props.profile.userid,
      ipupdate: props.publicIPInfo,
      deviceupdate: 'Portal',
    }
    setUserUpdate(_reg);
    setUserIDUpdate(_id);
    if (props.toggleShowModalQuestionYesNoDetail) {
      props.toggleShowModalQuestionYesNoDetail(true);
    }
  }

  React.useEffect(() => {
    setFieldActive(props.item.active ? props.item.active : false);
    setFieldDepartment(props.item.department ? props.item.department : '');
    formDefault.current.setFieldValue('active', props.item.active ? props.item.active : false);
    formDefault.current.setFieldValue('department', props.item.department ? props.item.department : '');
  }, [props.item, props.dateUpdateInfo])

  const toggleAnswerDetail = (key: string) => {
    switch (key) {
      case TypeAnswerConstant.YES:
      case TypeAnswerConstant.OK:
        props.toggleSetUsers(userUpdate, userIDUpdate);
        break;
      default:
        break;
    }
  }

  const handlerModalQuestion: IModalQuestionYesNoPage = {
    ...props,
    titlePage: 'Confirmação',
    question: 'Deseja alterar o registro?',
    toggleAnswer: toggleAnswerDetail,
    toggleShowModalQuestion: props.toggleShowModalQuestionYesNoDetail
  }

  return (
    <Box id="UserDetail" key="UserDetail" className="ChildrenRoot">
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography component="div" align="left" sx={{ alignContent: 'center', alignItems: 'center' }}>
            <Box id="BreadcrumbsBox" className="Breadcrumbs">
              <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" to={HOME}>
                  <FontAwesomeIcon icon={faHomeAlt} />
                </Link>
                <Link color="inherit" to={USERS}>
                  Usuários
                </Link>
              </Breadcrumbs>
            </Box>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <UserHeaderPage {...props} />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Form
            ref={formDefault}
            id="myFormDefault"
            name="myFormDefault"
            onSubmit={handleSubmit}
          >
            <Grid container spacing={1}>
              <Grid item xs={6} sm={4} md={3} lg={3} xl={3}>
                {props.isTypeGroupEdit &&
                  <Typography component="div" align="left" sx={{ padding: '0px 5px 5px 0px' }}>
                    <Button
                      variant="contained"
                      color="success"
                      className="ButtonPrimary"
                      type="submit"
                    >
                      <span>Salvar detalhes</span>
                    </Button>
                  </Typography>
                }
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography component="div" align="left">
                  <FieldsByGroupCustomPage
                    expanded={true}
                    title='Informações do Usuário'
                    structure={props.structure}
                    fields={props.item}
                    isTypeGroupEdit={props.isTypeGroupEdit ? true : false}
                    dateUpdateInfo={props.dateUpdateInfo}
                    handleChangeCurrency={handleChangeCurrency}
                    handleChange={handleChangeSelect}
                  />
                </Typography>
              </Grid>
            </Grid>
          </Form>
        </Grid>
      </Grid>
      {props.showModalQuestionYesNoDetail &&
        <ModalQuestionYesNoPage {...handlerModalQuestion} />
      }
    </Box>
  )
}


export default UserDetailPage;
